import * as styles from "./IntroRehomingListings.module.scss";

import React from "react";

export interface SectionSpotlightDogsProps {
	title: string;
	body: string;
}

export const IntroRehomingListings: React.FC<SectionSpotlightDogsProps> = ({
	title,
	body,
}) => {
	return (
		<div className={styles.introcolumnouter}>
			<div className={styles.introcolumninner}>
				<div className={styles.content}>
					<div className={styles.text}>
						<h1 className={styles.title}>{title}</h1>
						{/* biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source */}
						{body && <div dangerouslySetInnerHTML={{ __html: body }} />}
					</div>
				</div>
			</div>
		</div>
	);
};

export default IntroRehomingListings;
